module.exports = __webpack_public_path__ + "img/user-purple.ba39c1b7.svg";